export default "__VITE_PUBLIC_ASSET__5dee6c15__"